// extracted by mini-css-extract-plugin
export default {"li":"Resume_li__w-aix"};